import { Route } from 'react-router-dom';

import type { IAccessoriesCatalogActivity } from '../types/IAccessoriesCatalogActivity';
import { getAllRoutes } from '../utils/routes';
import AccessoriesCatalogActivity from './AccessoriesCatalogActivity';
import { ActivityRouteContainer } from './AccessoriesCatalogActivity.style';
import { AccessoriesCatalogSlideOut } from './AccessoriesCatalogSlideOut';

const Root = (props: IAccessoriesCatalogActivity) => {
    const { root } = getAllRoutes(props.baseRoute);

    return (
        <ActivityRouteContainer data-testid="activities-accessories-catalog-container" className="activities-accessories-catalog">
            <Route path={root} component={AccessoriesCatalogActivity} />
            <AccessoriesCatalogSlideOut />
        </ActivityRouteContainer>
    );
};

Root.displayName = 'AccessoriesCatalogActivity';

export default Root;
